import { render } from "./AppSidebar.vue?vue&type=template&id=74f33678&scoped=true&ts=true"
import script from "./AppSidebar.vue?vue&type=script&lang=ts"
export * from "./AppSidebar.vue?vue&type=script&lang=ts"

import "./AppSidebar.vue?vue&type=style&index=0&id=74f33678&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74f33678"]])

export default __exports__